import config from '../../config';
import { HTTP } from  '../../http';
import moment from 'moment';
import _ from "lodash";

const pageSize = 25
const moneyOutGroupUri = config.apiEndpoints.moneyOutGroupUri
const moneyOutGroupStatuses = [
    {id: "CREATED", name: "Criado"},
    {id: "PROCESSING", name: "Processando"},
    {id: "DONE", name: "Finalizado"},
    {id: "CANCELED", name: "Cancelado"},
]
export default
{
    findAll: (request, page) => {
        request.startDate = request.startDate == '' ?  '' : moment(request.startDate).format()
        request.endDate = request.endDate == '' ?  '' : moment(request.endDate).format()
        return new Promise((resolve, reject) => {            
            HTTP.get(`${moneyOutGroupUri}search?status=${request.status}&pageSize=${pageSize}&page=${page}&startDate=${request.startDate}&endDate=${request.endDate}`)
            .then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    all: (keywords) => {
        return new Promise((resolve, reject) => {
            HTTP.get(moneyOutGroupUri.concat(`?keywords=${keywords}`)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    create: (entity) => {
        return new Promise((resolve, reject) => {
            HTTP.post(moneyOutGroupUri, entity).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    find: (id) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(moneyOutGroupUri.concat(id)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    getStatuses: () => {
        return _.clone(moneyOutGroupStatuses);
    },
    getStatus: (id) => {
        return moneyOutGroupStatuses.find(function(el) { return el.id == id });
    },
    updateStatus: (request) => {
        return new Promise((resolve, reject) => {
            HTTP.put(`${moneyOutGroupUri}${request.id}/status/`, { status: request.status }).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    createSendFile: (request) => {
        return new Promise((resolve, reject) => {
            HTTP.post(`${moneyOutGroupUri}${request.id}/sendfile/`).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    }
}